(function () {
  const MAX_FILE_SIZE = 20 * 1024 * 1024;
  const ACCEPTED_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];

  function initHoleInOneUpload(root) {
    const input = root.querySelector('[data-hole-in-one-upload-input]');
    const zone = root.querySelector('[data-hole-in-one-upload-zone]');
    const empty = root.querySelector('[data-hole-in-one-upload-empty]');
    const preview = root.querySelector('[data-hole-in-one-upload-preview]');
    const previewImage = root.querySelector('[data-hole-in-one-upload-img]');
    const changeButton = root.querySelector('[data-hole-in-one-upload-change]');
    const removeButton = root.querySelector('[data-hole-in-one-upload-remove]');
    const error = root.querySelector('[data-hole-in-one-upload-error]');

    if (!input || !zone || !empty || !preview || !previewImage) return;

    let previewUrl = null;

    function clearError() {
      if (!error) return;
      error.textContent = '';
      error.classList.remove('is-visible');
    }

    function showError(message) {
      if (!error) return;
      error.textContent = message;
      error.classList.add('is-visible');
    }

    function revokePreviewUrl() {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
        previewUrl = null;
      }
    }

    function showEmptyState() {
      revokePreviewUrl();
      input.value = '';
      previewImage.removeAttribute('src');
      preview.classList.remove('is-visible');
      empty.classList.remove('is-hidden');
      clearError();
    }

    function showPreviewState(file) {
      revokePreviewUrl();
      previewUrl = URL.createObjectURL(file);
      previewImage.src = previewUrl;
      previewImage.alt = file.name;
      empty.classList.add('is-hidden');
      preview.classList.add('is-visible');
      clearError();
    }

    function validateFile(file) {
      if (!file) return false;

      if (!ACCEPTED_TYPES.includes(file.type)) {
        showError('Please upload a JPG, PNG, WEBP, or GIF image.');
        return false;
      }

      if (file.size > MAX_FILE_SIZE) {
        showError('Image must be 20MB or smaller.');
        return false;
      }

      return true;
    }

    function handleFile(file) {
      if (!validateFile(file)) {
        input.value = '';
        return;
      }

      showPreviewState(file);
    }

    input.addEventListener('change', function () {
      const file = input.files && input.files[0];
      if (!file) {
        showEmptyState();
        return;
      }

      handleFile(file);
    });

    zone.addEventListener('click', function (event) {
      if (event.target.closest('[data-hole-in-one-upload-change], [data-hole-in-one-upload-remove]')) {
        return;
      }

      input.click();
    });

    if (changeButton) {
      changeButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        input.click();
      });
    }

    if (removeButton) {
      removeButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        showEmptyState();
      });
    }

    ['dragenter', 'dragover'].forEach(function (eventName) {
      zone.addEventListener(eventName, function (event) {
        event.preventDefault();
        zone.classList.add('is-dragover');
      });
    });

    ['dragleave', 'drop'].forEach(function (eventName) {
      zone.addEventListener(eventName, function (event) {
        event.preventDefault();
        zone.classList.remove('is-dragover');
      });
    });

    zone.addEventListener('drop', function (event) {
      const file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
      if (!file) return;

      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);
      input.files = dataTransfer.files;
      handleFile(file);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-hole-in-one-upload]').forEach(initHoleInOneUpload);
  });
})();
